export default function() {
  const accordionTriggers = document.querySelectorAll('.js-accordion-trigger');
  const activeClass = 'active';

  [...accordionTriggers].forEach(trigger => {
    trigger.addEventListener('click', () => {
      const content = trigger.nextElementSibling;

      if (!trigger.classList.contains(activeClass)) {
        trigger.classList.add(activeClass);
        content.style.height = `${content.scrollHeight}px`;
      } else {
        trigger.classList.remove(activeClass);
        content.style.height = 0;
      }
    });

    if (trigger.classList.contains('init')) {
      trigger.click();
    }
  });

  const accordionActive = 'accordion__title--active';
  [...document.querySelectorAll('.accordion__title')].forEach(trigger => {
    trigger.addEventListener('click', () => {
      const content = trigger.nextElementSibling;

      if (!trigger.classList.contains(accordionActive)) {
        trigger.classList.add(accordionActive);
        content.style.height = `${content.scrollHeight}px`;
      } else {
        trigger.classList.remove(accordionActive);
        content.style.height = 0;
      }
    });
  });
}
